import { BUTTON_STYLE, PLAY } from '@constants/provider';

export interface UpsellItemParams {
    rangeNg: string;
    commercialSeries: string;
    play?: PLAY;
    isHiddenDefault?: boolean;
}

export enum UpsellModalComponentType {
    CLASSIC = 'classic',
    BYOU = 'byou',
    DOWNGRADE_MUST_PLAY = 'downgrade-must-play',
    DOWNGRADE_ULTYM_PLAY = 'downgrade-ultym-play',
}

export interface UpsellItemsConfiguration {
    baseProduct: UpsellItemParams;
    upselledProduct?: UpsellItemParams;
    modalComponentType?: UpsellModalComponentType;
}

export interface MismatchConfig {
    title?: string;
    icon?: string;
    iconColor?: string;
    text?: string;
    alertTitle?: string;
    alertDescription?: string;
    showAddress?: boolean;
    showDivider?: boolean;
    buttonLabel?: string;
    buttonStyle?: BUTTON_STYLE;
    ctaRedirectUrl?: string;
    trackingClic?: { [key: string]: string };
    trackingImpression?: { [key: string]: string };
    alwaysShowCta?: boolean;
}
